export const photoConstants = {
    // Add and editing photo
    SAVING_PHOTO_REQUEST: 'SAVING_PHOTO_REQUEST',
    SAVING_PHOTO_SUCCESS: 'SAVING_PHOTO_SUCCESS',
    SAVING_PHOTO_FAILURE: 'SAVING_PHOTO_FAILURE',

    // Loading photos
    LOAD_PHOTOS_REQUEST: 'LOAD_PHOTOS_REQUEST',
    LOAD_PHOTOS_SUCCESS: 'LOAD_PHOTOS_SUCCESS',
    LOAD_PHOTOS_FAILURE: 'LOAD_PHOTOS_FAILURE',

    // Delete photo
    DELETE_PHOTO_REQUEST: 'DELETE_PHOTO_REQUEST',
    DELETE_PHOTO_SUCCESS: 'DELETE_PHOTO_SUCCESS',
    DELETE_PHOTO_FAILURE: 'DELETE_PHOTO_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/photo.constants.js